import React from "react";
import { Box } from "@mui/material";
import Heading from '../../Components/heading.tsx';
import "../../../WebApp/Components/globalVariables.js";

const WebViewTermsOfService: React.FC = () => {
  const handleBack = () => window.history.back();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
        m: 0,
        p: 0,
      }}
    >
      <Box
        sx={{
          flexShrink: 0,
          position: "sticky",
          top: 0,
          backgroundColor: "#fff",
          zIndex: 1100,
          pt: "30px",  
          pb: "8px",
        }}
      >
        <Heading title="Terms of Service" onBackClick={handleBack} />
      </Box>
      <Box sx={{ flex: 1 }}>
        <iframe
          src={global.terms_of_service_viewer} 
          title="Terms of Service"
          style={{ width: "100%", height: "100%", border: "none" }}
        />
      </Box>
    </Box>
  );
};

export default WebViewTermsOfService;
